import { Button } from '@chakra-ui/button';
// import { Button, IconButton } from '@chakra-ui/button'; (Supports circle link to pages)
import { Image } from '@chakra-ui/image';
import { SimpleGrid } from '@chakra-ui/layout';
import Flip from 'react-reveal/Flip';
import Fade from 'react-reveal/Fade';
import Bounce from 'react-reveal/Bounce';
import { Box, Container, Flex, Text } from '@chakra-ui/layout'
import {Input, useToast, Alert, AlertIcon, AlertTitle, AlertDescription } from '@chakra-ui/react';
import { HashLink } from 'react-router-hash-link';
import React, { useState } from 'react'
import Logo from '../../components/logo'
import Nav from '../../components/nav';
// import womanImg from '../../img/woman-img-big.svg';
import { svg } from '../../svg';
import style from './style.module.css';
import womanFrontOfPepperIMG from '../../img/woman_in_front_of_pepper.png';
import girlFoldingHands from '../../img/girl_folding_hands.png';
import manPhone from '../../img/man_phone.png';
import bitcoinImg from '../../img/bitcoin-img.png';
import phoneImg from '../../img/uiphone_img.png';
import manCompass from '../../img/man_compass.png';

import facebookImg from '../../img/facebook.svg';
import twitterImg from '../../img/twitter.svg';
import instagramImg from '../../img/instagram.svg';
import linkedinImg from '../../img/linkedin.svg';
import smallFlash from '../../img/small_flash.svg';

import { useHistory } from 'react-router-dom';
import { FormControl } from '@chakra-ui/form-control';
import { FormLabel } from '@chakra-ui/form-control';

import { Link } from "@chakra-ui/react"

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import useQuery from '../../hook/useQuery';

const axios = require('axios').default;
axios.defaults.baseURL = 'https://bridgy-beta.herokuapp.com/api/v1/';
// axios.defaults.baseURL = 'http://localhost:4004/api/v1/';
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded';

const schema = yup.object().shape({
  email: yup.string().email().required(),
  fullname: yup.string().min(2).required(),
  phonenumber: yup.number().min(10).required(),
});


function Home() {

    const { register, handleSubmit, formState:{ errors }} = useForm({
        resolver: yupResolver(schema),
      });
      const [loading, setLoading] = useState(false);
      const [signupSuccess, setSignupSuccess] = useState(false);
    
      let query = useQuery();
      const toast = useToast();
      const history = useHistory();
    
      const onSubmit = data => {
        const { phonenumber, email, fullname } = data;
        const referral = query.get('code');
        
        setLoading(true);

        axios
        .post('/join', {
            phone: phonenumber,
            name: fullname,
            profession: "swift finance data",
            email,
            referrer: referral || undefined,
          })
          .then(function (response) {
            if (response.data) {
              setSignupSuccess(true)
              toast({
                title: "Congratulations, You're one step away from joining",
                position: 'top-right',
                description: "Kindly confirm your email address",
                status: 'success',
                duration: 5000,
                isClosable: true,
              });
    
              localStorage.setItem(
                'referralCode',
                JSON.stringify(response.data.referrerCode)
              );
                history.push(`/invite?code=${response.data.referrerCode}`)
            }
          })
          .catch(function (error) {
            setLoading(false);
            if (error.response && error.response.data.message.indexOf('mail already exists') !== -1){
              return toast({
                title: 'Opps!',
                position: 'top-right',
                description: 'This Email Is Already Registered',
                status: 'error',
                duration: 9000,
                isClosable: true,
              });
            }else if (error.message && error.message.indexOf('Network Error') !== -1) {
              return toast({
                title: 'Network Error',
                position: 'top-right',
                description: 'Looks Like you are not connected to the internet',
                status: 'warning',
                duration: 9000,
                isClosable: true,
              });
            }else  {
              return toast({
                title: 'Opps!',
                position: 'top-right',
                description: 'Something went wrong',
                status: 'error',
                duration: 9000,
                isClosable: true,
              });
            }
          });
      };


    return (
        <Container maxW="100%" padding="0px" overflowX="hidden">
            <Box height="100%" paddingTop="22px" overflow="hidden" width="100%"
                background="radial-gradient(circle, rgba(104,56,219,1) 0%, rgba(56,30,119,1) 100%, rgba(54,29,114,1) 100%)">
                <header>
                    <nav>
                        <Flex justifyContent="space-between">
                            <Fade>
                                <Logo width="165px" className={style.homepage_logo} style={{ marginLeft: '34px' }} />
                            </Fade>

                            <Nav/>
                        </Flex>
                    </nav>
                </header>

                <Flex justifyContent="space-between"  paddingTop={{ sm: "45px", md: "20px", lg: "35px" }} className={style.topContainer} flexDirection={{ base: "column", md: "column", lg: "row" }}>
                    <Box paddingTop="20px" width={{ sm: "85%", md: "85%", lg: "60%" }} paddingLeft="32px">
                        <Box as="h1" className={style.heading_text} color="primary.100">
                            <Box open={'auto'} delay={300}>
                                <Box className={style.main_text}>Grow your business with digital banking tools</Box>
                            </Box>
                        </Box>

                        <Fade delay={1050}>
                            <Text as="h3" padding={{base: "0 10px", md: "0", lg: "0"}} className={style.header_text_details} marginTop="23px" color="white">Save money, make payments and get instant loans. Manage your money anywhere you go around the world with just your phone number.</Text>
                            <HashLink to="#early-access-form">
                            <Button id={style.create_acc_btn}> Create a free account <svg className="w-6 h-6" style={{ width: "25px", height: "25px", position: "absolute", right: "20px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" /></svg></Button>
                            </HashLink>
                        </Fade>
                    </Box>

                    <Fade>
                        <Image src={phoneImg} marginRight={{ sm: "auto", md: "auto", lg: "100px" }} className={style.hero_image} width={{ sm: "330px", md: "330px", lg: "430px" }} marginLeft={{ sm: "auto", md: "auto" }} alt="" aria-label="Woman with swift logo" />
                    </Fade>
                </Flex>
            </Box>

            <Box as="main" width="100%" pt="50px" pb="100px" backgroundColor="primary.200">
                <Flip cascade left>
                    <Text textAlign="center" mb="10px" p="0 5px" fontSize="35px" fontWeight="600" bgGradient="linear(to-l, rgba(104,56,219,1), rgba(54,29,114,1),#FF0080)" bgClip="text" as="h1" padding="0px 20px"> What can you do with Swift Finance? </Text>
                </Flip>
                <Text as="h3" width={{base: "90%", sm: "90%", lg: "80%"}} margin="auto" textAlign="center" fontSize="20px" fontWeight="500"> You can save money, pay bills and get quick business loans with easy and flexible repayment plans. You can also manage and track your income with our insights tool, send and recieve money both home and abroad all in one app. <br/> <br/> We make it easy for you to focus on running your business and worry less about recieving payments or managing your income. Create a business account, even if you have not registered your business. </Text>


                <SimpleGrid columns={{ base: 2, md: 3, lg: 4 }} spacing="10px" mt="35" ml="5" mr="5" className={style.icons_grid_box}>
                    <Bounce>
                        <Box w="100%" h="150" display="flex" flexDirection="column" justifyContent="space-around" alignItems="center" >
                            {svg.payBillsSvg()}
                            <Text as="h3" margin="auto"
                                textAlign="center"
                                fontSize="20px"
                                fontWeight="600">Pay Bills</Text>
                        </Box>
                    </Bounce>

                    <Bounce>
                        <Box w="100%" h="150" display="flex" flexDirection="column" justifyContent="space-around" alignItems="center" >
                            {svg.saveMoneySvg()}
                            <Text as="h3" margin="auto" textAlign="center" fontSize="20px" fontWeight="600">Flexible Savings</Text>
                        </Box>
                    </Bounce>

                    <Bounce>
                        <Box w="100%" h="150" display="flex" flexDirection="column" justifyContent="space-around" alignItems="center" >
                            {svg.instantLoanSvg()}
                            <Text as="h3" margin="auto" textAlign="center" fontSize="20px" fontWeight="600">Instant Loans</Text>
                        </Box>
                    </Bounce>

                    <Bounce>
                        <Box w="100%" h="150" display="flex" flexDirection="column" justifyContent="space-around" alignItems="center" >
                            {svg.atmCard()}
                            <Text as="h3" margin="auto" textAlign="center" fontSize="20px" fontWeight="600">Track Your Income</Text>
                        </Box>
                    </Bounce>

                    <Bounce>
                        <Box w="100%" h="150" mt="20px" display="flex" flexDirection="column" justifyContent="space-around" alignItems="center" >
                            {svg.freeTransferSvg()}
                            <Text as="h3" margin="auto" textAlign="center" fontSize="20px" fontWeight="600"> International Payments </Text>
                        </Box>
                    </Bounce>

                    <Bounce>
                        <Box w="100%" h="150" mt="20px" display="flex" flexDirection="column" justifyContent="space-around" alignItems="center" >
                        <Box mt="10px" mb="10px"> {svg.phoneIconSvg()} </Box>
                            <Text as="h3" margin="auto" textAlign="center" fontSize="20px" fontWeight="600"> Safe And Secure </Text>
                        </Box>
                    </Bounce>

                    <Bounce>
                        <Box w="100%" h="150" mt="20px" display="flex" flexDirection="column" justifyContent="space-around" alignItems="center" >
                            <Box mt="10px" mb="10px"> {svg.cryptoIconSvg()} </Box>
                            <Text as="h3" margin="auto" textAlign="center" fontSize="20px" fontWeight="600">A+ Customer Support</Text>
                        </Box>
                    </Bounce>


                    <Bounce>
                        <Box w="100%" h="150" mt="20px" display="flex" flexDirection="column" justifyContent="space-around" alignItems="center" >
                            {svg.hiddenChargesSvg()}
                            <Text as="h3" margin="auto" textAlign="center" fontSize="20px" fontWeight="600">No Hidden Charges</Text>
                        </Box>
                    </Bounce>
                </SimpleGrid>

            </Box>

            <Box width="100%" backgroundColor="primary.100" pt="50px">
                <Text textAlign="center" mt="20px" mb="10px" fontSize="35px" fontWeight="600" bgGradient="linear(to-l, rgba(104,56,219,1), rgba(54,29,114,1),#FF0080)" bgClip="text" as="h1" padding="0px 20px"> Take a deep dive into what Swift Finance can do for your business </Text>
                <Text as="h3" width={{base: "90%", sm: "90%", lg: "80%"}} margin="auto" textAlign="center" fontSize="20px" fontWeight="500"> Managing your money shouldn't be rocket science; enjoy high end customer support, world class security that protects your account from scammers and offline services that allows you have access to your money even without the internet. </Text>

                <Flex m="100px 0 100px 0" className={style.flex_odd_div} justifyContent="space-between">
                    <Box className={style.homepage_img_container} margin={{ base: "0 40px 0 40px", md: "0 40px 0 40px", lg: "0 100px 0 100px" }}>
                        <Fade left>
                            <Image src={womanFrontOfPepperIMG} loading="lazy" className={style.gallery_img} />
                        </Fade>
                    </Box>

                    <Box w="70%" className={style.homepage_text_container} marginRight={{ base: "40px", md: "40px", lg: "100px" }} paddingTop="50px">
                        <Text mb="10px" fontSize="30px" fontWeight="600" className={style.gallery_text_title} as="h1" bgGradient="linear(to-l, rgba(104,56,219,1), rgba(54,29,114,1),#FF0080)" bgClip="text">Payments: Accept money online and offline </Text>
                        <Text as="h3" className={style.gallery_text_body}> Running a business is difficult already, getting paid shouldn't be, that is why we help you recieve payments accross multiple channels. You can recieve money via your phone number, swift-tag (e.g @JennyStores), USSD short code (*1234#), and on the web with bank transfers and debit cards. </Text>

                        <Text as="h3" marginTop="20px" className={style.gallery_text_body}> If you run a physical store, your customers can also pay via POS and get instant reciepts on sucessful transactions. You also get to enjoy low transaction fees and faster processing time than ever before.</Text>

                        {/* <Link className={style.link_container}>
                            <Flex className={style.link_div_wrapper}>
                                <IconButton className={style.link_icon} aria-label="Learn more about Swift Savings" icon={<svg width="25px" className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>} />

                                    <Text color="#753FF6" className={style.link_text}>
                                        <HashLink to="#early-access-form">
                                        Learn more about Swift savings
                                        </HashLink>
                                    </Text>
                            </Flex>
                        </Link> */}
                    </Box>
                </Flex>


                <Flex m="100px 0 100px 0" className={style.flex_even_div} justifyContent="space-between">
                    <Box className={style.homepage_text_container} w="70%" marginLeft={{ base: "40px", md: "40px", lg: "100px" }} paddingTop="50px">
                        <Text mb="10px" fontSize="30px" fontWeight="600" className={style.gallery_text_title} as="h1" bgGradient="linear(to-l, rgba(104,56,219,1), rgba(54,29,114,1),#FF0080)" bgClip="text"> Savings: Create multiple savings plans </Text>
                        <Text as="h3" className={style.gallery_text_body}> You can save towards paying your office rent, buying an equipment or expanding your business. Whatever the case may be, Swift Finance allows you save in 3 different ways: </Text>

                        <Text as="h3" marginTop="20px" className={style.gallery_text_body}> (1) Save Periodically: You can choose to save daily, weekly or monthly on your terms automatically or manually. </Text>

                        <Text as="h3" marginTop="20px" className={style.gallery_text_body}> (2) Target Savings: Save to meet your desired financial goal e.g save 200,000 for new equipments  in 3 months. </Text>

                        <Text as="h3" marginTop="20px" className={style.gallery_text_body}> (3) Locked Savings: Lock your money for a specific period of time where you have no access till it's time to withdraw. </Text>

                    </Box>

                    <Box className={style.homepage_img_container} margin={{ base: "0 0px 0 0px", md: "0px 40px 0px 40px", lg: "0 100px 0 100px" }} >
                        <Fade right>
                            <Image src={girlFoldingHands} loading="lazy" className={style.gallery_img} />
                        </Fade>
                    </Box>
                </Flex>

                <Flex m="100px 0 100px 0" className={style.flex_odd_div} justifyContent="space-between">
                    <Box className={style.homepage_img_container} margin={{ base: "0 40px 0 40px", md: "0 40px 0 40px", lg: "0 100px 0 100px" }}>
                        <Fade left>
                            <Image src={manPhone} loading="lazy" className={style.gallery_img} />
                        </Fade>
                    </Box>

                    <Box w="70%" className={style.homepage_text_container} marginRight={{ base: "40px", md: "40px", lg: "100px" }} paddingTop="50px">
                        <Text mb="10px" fontSize="30px" fontWeight="600" className={style.gallery_text_title} as="h1" bgGradient="linear(to-l, rgba(104,56,219,1), rgba(54,29,114,1),#FF0080)" bgClip="text">Insights: Track and manage your income</Text>
                        <Text as="h3" className={style.gallery_text_body} >With Swift Finance, managing your income has never been this easy:</Text>

                        <Text as="h3" marginTop="20px" className={style.gallery_text_body}> Stay in control of your cash, record your transactions, create smart budgets, send reciepts and invoices. Manage your money across multiple banks, track which products or services are bringing you the most money. Get detailed financial reports periodically, understand how you basically use your money. </Text>

                    </Box>
                </Flex>


                <Flex m="100px 0 100px 0" className={style.flex_even_div} justifyContent="space-between">
                    <Box className={style.homepage_text_container} w="70%" marginLeft={{ base: "40px", md: "40px", lg: "100px" }} paddingTop="50px">
                        <Text mb="10px" fontSize="30px" fontWeight="600" className={style.gallery_text_title} as="h1" bgGradient="linear(to-l, rgba(104,56,219,1), rgba(54,29,114,1),#FF0080)" bgClip="text"> Loans: Get quick loans with flexible repayment plans </Text>
                        <Text as="h3" className={style.gallery_text_body} > Access business loans that are fast and seamless, get up to 1 million naira at very low interest rates with flexible repayment benefits. No collateral, no gruesome paper work, no standing on long queues at the bank. </Text>

                        <Text as="h3" marginTop="20px" className={style.gallery_text_body} > We undertand that money is an important growth factor in a business, that is why we are commited to helping you solve all your money problems. </Text>

                    </Box>

                    <Box className={style.homepage_img_container} margin={{ base: "0 40px 0 40px", md: "0 40px 0 40px", lg: "0 100px 0 100px" }} >
                        <Fade right>
                            <Image src={bitcoinImg} loading="lazy" className={style.gallery_img} />
                        </Fade>
                    </Box>
                </Flex>

                <Flex m="100px 0 100px 0" className={style.flex_odd_div} justifyContent="space-between">
                    <Box className={style.homepage_img_container} margin={{ base: "0 40px 0 40px", md: "0 40px 0 40px", lg: "0 100px 0 100px" }}>
                        <Fade left>
                            <Image src={manCompass} loading="lazy" className={style.gallery_img} />
                        </Fade>
                    </Box>

                    <Box w="70%" className={style.homepage_text_container} marginRight={{ base: "40px", md: "40px", lg: "100px" }} paddingTop="50px">
                        <Text className={style.gallery_text_title} as="h1" bgGradient="linear(to-l, rgba(104,56,219,1), rgba(54,29,114,1),#FF0080)" bgClip="text"> International Payments: One account, multiple currencies </Text>
                        <Text as="h3" className={style.gallery_text_body}>Moving money across different currencies has never been this easy. You don't need seperate accounts to recieve Naira, Dollar or British Pounds, when you have a Swift Finance account that supports multiple currencies. </Text>

                        <Text as="h3" marginTop="20px" className={style.gallery_text_body}> You can now enjoy low cross border rates, faster transactions and high grade security all in one app. </Text>

                    </Box>
                </Flex>
            </Box>

            <Box as="main" width="100%" pt="50px" pb="20px" backgroundColor="primary.200">
                <Flip cascade left>
                    <Text textAlign="center" p="0 5px" mb="10px" fontSize="35px" fontWeight="600" bgGradient="linear(to-l, rgba(104,56,219,1), rgba(54,29,114,1),#FF0080)" bgClip="text" as="h1"> Do so much more with Swift Finance </Text>
                </Flip>

                <Flex justifyContent="space-between" paddingBottom="200px" mt="50px" className={style.app_details_container}>
                    <Flex className={style.app_details_first_section} flexDirection="column" w="35%">
                        <Box className={style.app_div_details} >
                            <Text as="h2" fontWeight="bold">Safe and secure</Text>
                            <Text as="h5"> We protect your money from security thefts and scammers.</Text>
                        </Box>

                        <Box className={style.app_div_details}>
                            <Text as="h2" fontWeight="bold">Create multiple business accounts</Text>
                            <Text as="h5"> Manage all your business accounts on one app.</Text>
                        </Box>

                        <Box className={style.app_div_details} >
                            <Text as="h2" fontWeight="bold"> Cross platform support </Text>
                            <Text as="h5"> Available on Web, Android and iOS devices. </Text>
                        </Box>
                    </Flex>

                    <Box className={style.app_details_img} width="30%">
                        <Image src={phoneImg} />
                    </Box>

                    <Flex flexDirection="column" w="35%" className={style.app_details_second_section}>
                        <Box className={style.app_div_details} >
                            <Text as="h2" fontWeight="bold">No hidden fees</Text>
                            <Text as="h5">Our fees are clear as glass, no shaddy terms and conditions. </Text>
                        </Box>

                        <Box className={style.app_div_details}>
                            <Text as="h2" fontWeight="bold"> Team banking </Text>
                            <Text as="h5"> Manage the rights and access you give other members of your team. </Text>
                        </Box>

                        <Box className={style.app_div_details} id="early-access-form">
                            <Text as="h2" fontWeight="bold"> Pay online with virtual cards </Text>
                            <Text as="h5"> Buy things and pay for subscriptions (Coming Soon). </Text>
                        </Box>
                    </Flex>
                </Flex>
            </Box>

            <Box as="footer" pb="40px" pt="430px" position="relative" backgroundColor="#000000" >

                <Box className={style.early_access_form_container}>

                {signupSuccess ? (
                            <Alert
                                status="success"
                                variant="subtle"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                textAlign="center"
                                padding="20px"
                                height={{ base: '300px', md: '300px', xl: '300px' }}
                                backgroundColor="#0d5015"
                            >
                                <AlertIcon boxSize="40px" mr={0} />
                                <AlertTitle mt={2} mb={1} fontSize={{ base: 'sm', md: 'md', xl: 'xl' }}>
                                You have joined our waitlist!
                                </AlertTitle>
                                <AlertDescription fontSize={{ base: 'sm', md: 'md', xl: 'xl' }} maxWidth="sm">
                                Thanks for joining our wait list. A mail has been sent to you, check your current position on our leaderboard and 
                                stand a chance of winning amazing prizes
                                </AlertDescription>
                            </Alert>
            ) : (


                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Box display="inline-block" justifyContent="center" width="100%">
                        <Text as="h4" fontSize="25px" width="100%" fontWeight="700" textAlign="center" display="inline-block" justifyContent="center" alignItems="center"> <span display="inline-block"> Create a free account today and accelerate your business </span> <Image src={smallFlash} loading="lazy" height="30px" className={style.small_flash} /> </Text>
                        </Box>

                        <FormControl id="name" mt="40px">
                            <FormLabel fontSize="20px">Full name</FormLabel>
                            <Input isInvalid={errors.fullname && errors.fullname.message ? true: false} {...register("fullname")} name="fullname" placeholder="What is your full name?" className={style.early_access_form_input} type="text" />
                        </FormControl>

                        <FormControl id="email" mt="40px">
                            <FormLabel fontSize="20px">Email address</FormLabel>
                            <Input name="email"  isInvalid={errors.email && errors.email.message ? true: false}  {...register("email")}   placeholder="What is your email address?" className={style.early_access_form_input} type="email" />
                        </FormControl>

                        <FormControl id="phone_number" mt="40px">
                            <FormLabel fontSize="20px">Phone number</FormLabel>
                            <Input name="phonenumber"  isInvalid={errors.phonenumber && errors.phonenumber.message ? true: false} {...register("phonenumber")} placeholder="What is your phone number?" className={style.early_access_form_input} type="tel" />
                        </FormControl>

                        <Flex w="100%" >
                            <Button width="100%"
                                    transition=".2s ease"
                                    _hover={{
                                        transform: "scale(0.98)",
                                        background: "#000000c2"
                                    }}
                                    margin="57px auto 0px auto"
                                    fontSize="20px"
                                    backgroundColor="black"
                                    borderRadius="34px"
                                    height="50px"
                                    loadingText="Please wait..."
                                    isLoading={loading}
                                     type="submit">Get Early Access</Button>
                        </Flex>
                    </form>
                     )}
                </Box>


                <Flex p={{base: "0 20px", md: "0 40px", lg: "0 40px"}} mt="150px" justifyContent="space-between" flexWrap="wrap">
                   <Box w={{base: "100%", md: "100%", lg: "290px"}} marginTop="5px">
                        <Logo width="160px"/>
                        <Text as="p" fontSize="16px" marginTop="5px" color="#828282">info@swiftfinance.app</Text>
                        <Text as="p" fontSize="16px" marginTop="5px" color="#828282">+234 903 329 2522</Text>
                        <Box className={style.socialicons_container}>
                        <Fade right>
                            <Link href="https://facebook.com/swiftfinanceapp/"> <Image src={facebookImg} loading="lazy" height="30px" className={style.social_icons} marginRight="10px"/> </Link>
                            <Link href="https://twitter.com/swiftfinanceapp"> <Image src={twitterImg} loading="lazy" height="30px" className={style.social_icons} marginRight="10px"/> </Link>
                            <Link href="https://instagram.com/swiftfinanceapp"> <Image src={instagramImg} loading="lazy" height="30px" className={style.social_icons} marginRight="10px"/> </Link>
                            <Link href="#"> <Image src={linkedinImg} loading="lazy" height="30px" className={style.social_icons} marginRight="10px"/> </Link>
                        </Fade>
                    </Box>
                   </Box>

                   <Flex flexDirection="column" w="180px" marginTop={{base: "30px", md: "30px", lg: "5px"}} marginRight="5px">
                        <Text as="p" fontSize="20px" marginTop="5px" color="white" fontWeight="bold">Products</Text>
                        <Link className={style.footer_links}>Payments</Link>
                        <Link className={style.footer_links}>Savings</Link>
                        <Link className={style.footer_links}>Loans</Link>
                        <Link className={style.footer_links}>Insights</Link>
                   </Flex>

                   <Flex flexDirection="column" w="180px" marginTop={{base: "30px", md: "30px", lg: "5px"}}  marginRight="5px">
                        <Text as="p" fontSize="20px" marginTop="5px" color="white" fontWeight="bold">Company</Text>
                        <Link className={style.footer_links}>About us</Link>
                        <Link className={style.footer_links}>FAQs</Link>
                        <Link className={style.footer_links}>Blog</Link>
                   </Flex>

                   <Flex flexDirection="column" w="180px" marginTop={{base: "30px", md: "30px", lg: "5px"}}  >
                       <Text as="p" fontSize="20px" marginTop="5px" color="white" fontWeight="bold">Legal</Text>
                       <Link className={style.footer_links}>Terms</Link>
                       <Link className={style.footer_links}>Privacy</Link>
                   </Flex>
                </Flex>

                <Text as="p" padding={{base: "0 20px", md: "0 40px", lg: "0 40px"}} marginTop="60px"  fontSize="16px" textAlign="center" color="#828282">
                    &copy; 2022 Swift Finance . All rights reserved. All deposits are insured by the Nigerian Deposit Insurance Corporation (NDIC).
                </Text>
            </Box>
        </Container>
    )
}

export default Home

// 
